export default __webpack_public_path__ + "c708722180e0c0cf7d2775efdb4bc591.png";